export default "__VITE_ASSET__ME4VBIsJ__"